// extracted by mini-css-extract-plugin
export default {"content":"SlideInContent_content__lEylC","inView":"SlideInContent_inView__Fae7D"};